import React, { useEffect, useState } from "react";
import Styles from "./ContractDetails.module.css";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { convertDate, formatDateType } from "../../../../commons/FormatDate";
import { useNavigate } from "react-router-dom";
import ChildTransaction from "../../../Modals/Payment/ChildTransaction/ChildTransaction";
import { walletChildTransaction } from "../../../../Services/Payments/PaymentApi";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import Skeleton from "@mui/material/Skeleton";
import {
  walletAccount,
  walletContract,
  walletTransaction,
} from "../../../../Redux/Slices/paymentSlice";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";

const ContractDetails = () => {
  const navigate = useNavigate();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.paymentSlice);
  let transaction = data?.walletTransaction;
  let contracts = data?.walletContract;
  let loading = data?.walletContractLoading || data?.walletTransactionLoading;
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  const [childTransaction, setChildTransaction] = useState([]);
  const [parentData, setParentData] = useState({});

  useEffect(() => {
    dispatch(walletTransaction({ page: 0, size: 10 }));
    if (wallet?.id) {
      dispatch(walletContract({ id: wallet?.id, page: 0, size: 10 }));
    }
  }, [dispatch, wallet?.id]);

  const handleNav = (val) => {
    navigate(val);
  };

  const handleChildTransaction = async (data) => {
    setParentData(data);
    let res = await walletChildTransaction(data?.id);
    if (res?.data?.code === 200) {
      setChildTransaction(res?.data?.data || []);
    } else {
      ErrorMessage(res?.data?.error || "Something went wrong");
    }
  };

  return (
    <>
      {
        <ChildTransaction
          open={childTransaction?.length > 0}
          handleClose={() => setChildTransaction([])}
          data={childTransaction}
          parentData={parentData}
        />
      }
      <div className={`display_flex_column ${Styles.detailsMainContainer}`}>
        <div>
          <div className={Styles.contractSectionHeader}>
            <div className={Styles.contractSectionTitle}>Contracts</div>

            <div
              className={Styles.viewAll}
              onClick={() => handleNav("/wallet_contract")}
            >
              View All
            </div>
          </div>
          {/* <div className={Styles.tableMainElem}>
            <div
              className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
            >
              <div style={{ width: "10%" }}>Contract Id</div>
              <div style={{ width: "10%" }}>Self Lisitng</div>
              <div style={{ width: "10%" }}>Counterparty</div>
              <div style={{ width: "10%" }}>Start and End Date</div>
              <div style={{ width: "10%" }}>Total Contract Value (₹)</div>
              <div style={{ width: "10%" }}>Amount Blocked (₹)</div>
              <div style={{ width: "10%" }}>Total Contract Schedule (MWH)</div>
              <div style={{ width: "10%" }}>Actual Delivery (MWH)</div>
              <div style={{ width: "10%" }}>Schedule</div>
              <div style={{ width: "5%" }}>Details</div>
            </div>
            <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
              {loading ? (
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="display_flex_row tableDetails" key={idx}>
                    <div style={{ width: "10%" }}></div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "5%" }}>
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                  </div>
                ))
              ) : contracts?.length > 0 && contracts !== null ? (
                contracts?.map((ele) => (
                  <div className="display_flex_row tableDetails" key={ele?.id}>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {" "}
                      {ele?.bilateralContractUniqueId || "-"}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {(role === "consumer"
                        ? ele?.name?.split("-")?.[0]?.includes("C")
                          ? ele?.name?.split("-")?.[0]
                          : ele?.name?.split("-")?.[1]
                        : ele?.name?.split("-")?.[1]?.includes("G")
                          ? ele?.name?.split("-")?.[1]
                          : ele?.name?.split("-")?.[0]
                      )?.split("_")?.[0] || "-"}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {role === "consumer"
                        ? `${ele?.generatorName || "-"}`
                        : role === "generator"
                          ? `${ele?.consumerName || "-s"}`
                          : `${ele?.consumerName}-${ele?.generatorName}`}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {`${formatDateType(ele?.startDate)} to ${formatDateType(
                        ele?.endDate,
                      )}`}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {ele?.scheduledAmount?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {(ele?.amountBlocked || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {(ele?.scheduledVolume || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%", fontSize: "11px" }}>
                      {(ele?.deliveredVolume || 0)?.toFixed(2)}
                    </div>
                    <div
                      style={{ width: "10%", fontSize: "11px" }}
                      className={`${
                        ele?.status === "COMPLETED"
                          ? "accepted"
                          : ele?.status === "PENDING"
                            ? "pending"
                            : "rejected"
                      }`}
                    >
                      {ele?.status === "COMPLETED"
                        ? "Completed"
                        : ele?.status === "PENDING"
                          ? "Ongoing"
                          : "Rejected"}
                    </div>
                    <div
                      style={{ width: "5%", fontSize: "11px" }}
                      onClick={() => {
                        handleChildTransaction(ele);
                      }}
                    >
                      <VisibilityIcon
                        style={{ fontSize: "14px", color: "var(--primary-color-text)" }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.noData}>No contracts available</div>
              )}
            </div>
          </div> */}
          <div className={Styles.contractTableWrapper}>
            {/* Header */}
            <div className={Styles.contractTableHeader}>
              <div className={Styles.contractColLg}>Contract Id</div>
              <div className={Styles.contractColSm}>Self Lisitng</div>
              <div className={Styles.contractColMd}>Counterparty</div>
              <div className={Styles.contractColLg}>Duration</div>
              <div className={Styles.contractColMd}>
                Total Contract Value (₹)
              </div>
              <div className={Styles.contractColMd}>Amount Blocked (₹)</div>
              <div className={Styles.contractColMd}>
                Total Contract Schedule (MWh)
              </div>
              <div className={Styles.contractColMd}>Actual Delivery (MWh)</div>
              <div className={Styles.contractColSm}>Schedule</div>
              <div className={Styles.contractAction}>Details</div>
            </div>

            {/* Body */}
            <div className={`${Styles.contractTableBody} scroll_bar_y`}>
              {loading ? (
                Array.from({ length: 4 }).map((_, idx) => (
                  <div className={Styles.contractRow} key={idx}>
                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>

                    <div className={Styles.contractColSm}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>

                    <div className={Styles.contractColMd}>
                      <Skeleton variant="text" width={90} height={20} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>

                    <div className={Styles.contractColMd}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>

                    <div className={Styles.contractColMd}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>

                    <div className={Styles.contractColMd}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>

                    <div className={Styles.contractColMd}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>

                    <div className={Styles.contractColSm}>
                      <Skeleton variant="rounded" width={70} height={28} />
                    </div>

                    <div className={Styles.contractAction}>
                      <Skeleton variant="circular" width={28} height={28} />
                    </div>
                  </div>
                ))
              ) : contracts?.length > 0 ? (
                contracts?.map((ele) => {
                  /* DELIVERY PERCENTAGE */
                  const deliveryPercentage = Math.min(
                    ((ele?.deliveredVolume || 0) /
                      (ele?.scheduledVolume || 1)) *
                      100,
                    100,
                  );

                  /* DYNAMIC DELIVERY GRADIENT */
                  const getDeliveryGradient = (percentage) => {
                    /* 0% to 30% */
                    if (percentage <= 30) {
                      return "linear-gradient(90deg, #f97316, #ea580c)";
                    }

                    /* 31% to 70% */
                    if (percentage <= 70) {
                      return "linear-gradient(90deg, #f59e0b, #facc15)";
                    }

                    /* 71% to 99% */
                    if (percentage < 100) {
                      return "linear-gradient(90deg, #84cc16, #22c55e)";
                    }

                    /* 100% */
                    return "linear-gradient(90deg, #16a34a, #15803d)";
                  };

                  return (
                    <div className={Styles.contractRow} key={ele?.id}>
                      {/* Contract ID */}
                      <div className={Styles.contractColLg}>
                        <div className={Styles.contractPrimaryText}>
                          {ele?.bilateralContractUniqueId || "-"}
                        </div>
                      </div>

                      {/* Self Listing */}
                      <div className={Styles.contractColSm}>
                        <div className={Styles.contractPrimaryText}>
                          {(role === "consumer"
                            ? ele?.name?.split("-")?.[0]?.includes("C")
                              ? ele?.name?.split("-")?.[0]
                              : ele?.name?.split("-")?.[1]
                            : ele?.name?.split("-")?.[1]?.includes("G")
                              ? ele?.name?.split("-")?.[1]
                              : ele?.name?.split("-")?.[0]
                          )?.split("_")?.[0] || "-"}
                        </div>
                      </div>

                      {/* Counterparty */}
                      <div className={Styles.contractColMd}>
                        <div className={Styles.contractPrimaryText}>
                          {role === "consumer"
                            ? ele?.generatorName || "-"
                            : role === "generator"
                              ? ele?.consumerName || "-"
                              : `${ele?.consumerName}-${ele?.generatorName}`}
                        </div>
                      </div>

                      {/* Date */}
                      <div className={Styles.contractColLg}>
                        <div className={Styles.contractPrimaryText}>
                          {formatDateType(ele?.startDate)}
                        </div>

                        <div className={Styles.contractSecondaryText}>
                          to {formatDateType(ele?.endDate)}
                        </div>
                      </div>

                      {/* Value */}
                      <div className={Styles.contractColMd}>
                        <div className={Styles.contractAmount}>
                          ₹ {ele?.scheduledAmount?.toFixed(2)}
                        </div>
                      </div>

                      {/* Blocked */}
                      <div className={Styles.contractColMd}>
                        <div className={Styles.contractBlocked}>
                          ₹ {(ele?.amountBlocked || 0)?.toFixed(2)}
                        </div>
                      </div>

                      {/* Schedule */}
                      <div className={Styles.contractColMd}>
                        <div className={Styles.contractMetric}>
                          {(ele?.scheduledVolume || 0)?.toFixed(2)} MWh
                        </div>
                      </div>

                      {/* Delivery */}
                      <div className={Styles.contractColMd}>
                        <div className={Styles.deliveryWrapper}>
                          <div className={Styles.deliveryBar}>
                            <div
                              className={Styles.deliveryFill}
                              style={{
                                width: `${deliveryPercentage}%`,
                                background:
                                  getDeliveryGradient(deliveryPercentage),
                              }}
                            />
                          </div>

                          <span className={Styles.deliveryText}>
                            {(ele?.deliveredVolume || 0)?.toFixed(0)} MWh
                          </span>
                        </div>
                      </div>

                      {/* Status */}
                      <div className={Styles.contractColSm}>
                        <div
                          className={`${Styles.contractStatus} ${
                            ele?.status === "COMPLETED"
                              ? Styles.statusCompleted
                              : ele?.status === "PENDING"
                                ? Styles.statusOngoing
                                : Styles.statusRejected
                          }`}
                        >
                          {ele?.status === "COMPLETED"
                            ? "Completed"
                            : ele?.status === "PENDING"
                              ? "Ongoing"
                              : "Rejected"}
                        </div>
                      </div>

                      {/* Action */}
                      <div
                        className={Styles.contractAction}
                        onClick={() => handleChildTransaction(ele)}
                      >
                        <div className={Styles.viewButton}>
                          <ViewIcon
                            style={{
                              width: "14px",
                              height: "14px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className={Styles.emptyContractState}>
                  No contracts available
                </div>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className={Styles.contractSectionHeader}>
            <div className={Styles.contractSectionTitle}>Transactions</div>
            <div
              className={Styles.viewAll}
              onClick={() => handleNav("/wallet_transaction")}
            >
              View All
            </div>
          </div>
          <div className={Styles.contractTableWrapper}>
            {/* HEADER */}
            <div className={Styles.contractTableHeader}>
              <div className={Styles.contractColLg}>Self Listing</div>

              <div className={Styles.contractColLg}>Counterparty Name</div>

              <div className={Styles.contractColLg}>Contract ID</div>

              <div className={Styles.contractColLg}>Transaction Date</div>

              <div className={Styles.contractColLg}>Transaction Amount (₹)</div>

              <div className={Styles.contractColLg}>Type</div>

              <div className={Styles.contractColLg}>Action</div>
            </div>

            {/* BODY */}
            <div className={Styles.contractTableBody}>
              {loading ? (
                Array.from({ length: 4 }).map((_, idx) => (
                  <div className={Styles.contractRow} key={idx}>
                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={70} height={18} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={100} height={18} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={120} height={18} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={90} height={18} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="text" width={100} height={18} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="rounded" width={70} height={24} />
                    </div>

                    <div className={Styles.contractColLg}>
                      <Skeleton variant="rounded" width={70} height={24} />
                    </div>
                  </div>
                ))
              ) : transaction?.length > 0 ? (
                transaction?.map((ele, index) => (
                  <div className={Styles.contractRow} key={ele?.id || index}>
                    {/* SELF LISTING */}
                    <div className={Styles.contractColLg}>
                      <div className={Styles.contractPrimaryText}>
                        {ele?.listingId?.split("_")?.[0] || "-"}
                      </div>
                    </div>

                    {/* COUNTERPARTY */}
                    <div className={Styles.contractColLg}>
                      <div className={Styles.contractPrimaryText}>
                        {(ele?.counterPartyName === "UNKNOWN"
                          ? ""
                          : ele?.counterPartyName) || "Not Generated"}
                      </div>

                      {ele?.counterPartyListingId && (
                        <div className={Styles.contractSecondaryText}>
                          {ele?.counterPartyListingId || "-"}
                        </div>
                      )}
                    </div>

                    {/* CONTRACT ID */}
                    <div className={Styles.contractColLg}>
                      <div className={Styles.contractPrimaryText}>
                        {ele?.bilateralContractUniqueId || "Not Generated"}
                      </div>
                    </div>

                    {/* DATE */}
                    <div className={Styles.contractColLg}>
                      <div className={Styles.contractPrimaryText}>
                        {convertDate(ele?.dateTime?.split(" ")?.[0])}
                      </div>

                      <div className={Styles.contractSecondaryText}>
                        {ele?.dateTime?.split(" ")?.[1]}
                      </div>
                    </div>

                    {/* AMOUNT */}
                    <div className={Styles.contractColLg}>
                      <div className={Styles.contractAmount}>
                        ₹ {ele?.amount?.toFixed(2)}
                      </div>
                    </div>

                    {/* TYPE */}
                    <div className={Styles.contractColLg}>
                      <div
                        className={Styles.contractStatus}
                        style={{
                          background: "#fff7ed",
                          color: "#ea580c",
                        }}
                      >
                        {ele?.paymentType?.split("_")?.join(" ") || "-"}
                      </div>
                    </div>

                    {/* ACTION */}
                    <div className={Styles.contractColLg}>
                      <div
                        className={`${Styles.contractStatus} ${
                          ele?.activity === "CREDIT" ||
                          ele?.activity === "RELEASED"
                            ? Styles.statusCompleted
                            : Styles.statusRejected
                        }`}
                      >
                        {ele?.activity}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.emptyContractState}>
                  No transactions available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContractDetails;
